import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { counterCardBySiteStyle } from './style/counterCardBySiteStyle'

import Xprt from '../../asset/images/xprt_icon.png'
import Enviromental from '../../asset/images/enviromental_icon.png'
import Agriculture from '../../asset/images/agriculture_icon.png'
import Energy from '../../asset/images/energy_icon.png'

const CounterCardBySite = (props) => {

    const { classes, counters } = props;
    const listImage = [Xprt, Enviromental, Agriculture, Energy]

    return (
        <div className={classes.containerCard}>
            {
                counters.sort((a, b) => (a.order - b.order)).map(counter => {
                    return (
                        <div className={classes.card} key={counter.Id}>
                            <img src={listImage[counter.order]} width='50' alt={counter.Total} />
                            <p className={classes.cardText}>{counter.Total}</p>
                        </div>
                    )
                })
            }
        </div>
    );
};

export default withStyles(counterCardBySiteStyle)(CounterCardBySite);